import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API } from "@/lib/api";

const BrandingContext = createContext({ logoUrl: null, refresh: () => {} });
export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }) {
  const [logoUrl, setLogoUrl] = useState(null);

  const refresh = useCallback(() => {
    api.get("/site-config")
      .then(({ data }) => {
        setLogoUrl(data?.logo_file_id ? `${API}/public-image/${data.logo_file_id}` : null);
      })
      .catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BrandingContext.Provider value={{ logoUrl, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}
